import { getConfig } from '../Config/ApplicationConfig';
import { getExecutor } from '../Shared/HttpRequestExecutor';
export var getClinicalDecisionData = function (config, authoringSystem, authoringSystemForeignKey, request) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).postCancellable("api/v1/cds/" + authoringSystem + "/" + authoringSystemForeignKey, config, request);
};
export var updateCdsDetail = function (updatePatientMedicationCds) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).put("api/v1/cds/update", updatePatientMedicationCds);
};
